import React from "react";

export default function SpClientrequirements() {
  return (
    <React.Fragment>
      <div className="row px-6 my-md-5">
        <div className="col-12 spClientRequirementDiv pt-5 pt-md-0">
          <div className="row align-items-center">
            <div className="col-md-6 ps-3 ps-md-5">
              <h2>Client's requirements</h2>
              <p>
                The client wanted to automate tedious workflows and centralize
                scattered data to improve project management and business
                growth. They required a single solution that could provide
                automated legal and financial documentation, simplified sales
                and payment tracking, and provide a clear overview of project
                management and compliance.
              </p>
            </div>
            <div className="col-md-6">
              <video
                width="100%"
                controls={false}
                loop
                autoPlay
                muted
                playsInline
                height={window.innerWidth < 900 ? "250px" : "400px"}
              >
                <source src="/images/SpRequirement.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
